import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FieldValues } from "react-hook-form";
import { FISCAL_YEAR_API } from "./apiRoutes";

interface OpenNewYearProps {
  communityId: string | number;
  data: FieldValues
}

const mutateOpenNewYear = async ({ communityId, data }: OpenNewYearProps) => {
  return axiosAuth.post(
    `${FISCAL_YEAR_API(communityId)}/open-new-year`,
    data
  );
};

const useOpenNewYearMutation = (
  options?: UseMutationOptions<any, any, OpenNewYearProps>
) =>
  useMutation({
    mutationFn: mutateOpenNewYear,
    ...options,
  });

export default useOpenNewYearMutation;